import * as yup from 'yup'

const penaltySchema = yup.object().shape({
  interestRate: yup
    .number()
    .typeError('Preencha este campo')
    .min(0, 'Digite um número maior ou igual a 0')
    .required(),
  finePercentage: yup
    .number()
    .typeError('Preencha este campo')
    .min(0, 'Digite um número maior ou igual a 0')
    .required(),
  gracePeriodDays: yup
    .number()
    .typeError('Preencha este campo')
    .min(0, 'Digite um número maior ou igual a 0')
    .lessThan(32, 'Digite um número menor ou igual a 31')
    .required(),
})

export default penaltySchema
